import { GrShare } from "react-icons/gr"

const ShareButton = () => {
  return <div className="flex items-center gap-2 border rounded px-3 py-2 hover:bg-[#fff] hover:text-[#fff] cursor-pointer">
    <GrShare />
  </div>
}

export default ShareButton